import { _ as _extends } from "@swc/helpers/_/_extends";
import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import classNames from 'classnames';
import { Typography } from 'seagull';
import styles from './LoadingText.module.scss';
export const LoadingText = (_0)=>{
    let {} = _0, props = _extends({}, _0);
    return /*#__PURE__*/ _jsxs(Typography, _object_spread_props(_object_spread({}, props), {
        className: styles.loadingDots,
        children: [
            "Loading",
            /*#__PURE__*/ _jsx("span", {
                className: classNames(styles.dot, styles.dot1),
                children: "."
            }),
            /*#__PURE__*/ _jsx("span", {
                className: classNames(styles.dot, styles.dot2),
                children: "."
            }),
            /*#__PURE__*/ _jsx("span", {
                className: classNames(styles.dot, styles.dot3),
                children: "."
            })
        ]
    }));
};
